class AmountInput {
	constructor(config) {
		this.config = Object.assign({
			scope: '.product-amount-input',
			amountButtonUp: '.change-input-number-button.up',
			submitButton: 'button[submit]',
			amountButtonDown: '.change-input-number-button.down',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		console.log(22,this.$scope);
		this.$scope.off('.amount');
		this.$scope.on('click.amount', this.config.amountButtonUp, this.incrementAmount.bind(this));
		this.$scope.on('click.amount', this.config.amountButtonDown, this.decrementAmount.bind(this));
		this.$scope.on('click.amount', this.config.submitButton, this.addToBasket.bind(this));
	}

	incrementAmount(e) {
		e.preventDefault();
		let $input = $(e.currentTarget).parents('.product-amount-input').find('input[type=number]');
		let currentValue = $input.val();
		let maxValue = $input.attr('max');

		currentValue++;
		currentValue = currentValue > maxValue ? maxValue : currentValue;
		$input.val(currentValue < 1 ? 1 : currentValue).trigger('change');
		return true;
	}

	addToBasket(e) {
		let item = jQuery(e.target).parents('.product-amount-input');
		console.log(43,item,item.data());
		jQuery.post(item.data('route'), {
			amount : item.find('input[name="amount"]').val()
		}, (response) => {
			console.log(jQuery(response.indicator_html).first().html());
			console.log($("div.winkelwagen-indicator-wrapper"));
			$("a.cart").parent().html(response['summary-bestelling']);


		});
		let $obj = $(e.target).parents('.product-card-component:first');
		console.log($obj.offset().top);
		let currentTop = $obj.offset().top - $(document).scrollTop();
		$obj.css({position: 'fixed', zIndex: 999, overflow: 'hidden', top: currentTop});
		$obj.removeClass('h-100')
		$obj.animate({
			top:'60px',
			right:'160px',
			height: '1px',
			width: '1px',
		}, {
			queue: false,
			duration: 1000,
			complete: () => {
				$obj.addClass('h-100');
				$obj.css({
					position: 'static',
					top: 'initial',
					right: 'initial',
					width: 'initial',
					height: 'initial',
					overflow: 'initial',
					zIndex: 9,
				});
				this.slideBasket();
			}
		});
	}
	slideBasket() {
		let basket = jQuery('a.cart').next();
		basket.addClass('is-open');
		basket.slideDown(10).delay(2500).slideUp(1500, function() {
			basket.css('display', '');
			basket.removeClass('is-open');
		});
	}
	decrementAmount(e) {
		e.preventDefault();
		let $input = $(e.currentTarget).parents('.product-amount-input').find('input[type=number]')
		let currentValue = $input.val();
		let minValue = $input.attr('min');

		currentValue--;
		currentValue = currentValue < minValue ? minValue : currentValue;
		$input.val(currentValue).trigger('change');
		return true;
	}
}

export default AmountInput;